module.exports = __webpack_public_path__ + "static/img/activity-scene-2.d1779a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-scene-2.jpg
// module id = SikL
// module chunks = 10